if (window.innerWidth < 749) {
    const activeTab = document.querySelector(".Blog_tabs .Blog_tab.active");

    if (activeTab) {
        activeTab.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
        });
    }
}